import Tooltips from './tooltips';

export * from './tooltips';

export default Tooltips;
